import React from "react";
import LabeledTextInput from "../../../../ui-components/molecules/labeled-inputs/labeled-text-input/labeledTextInput";
import { LabelModes } from "../../../../ui-components/molecules/labeled-inputs/labeledInput";
import XGSSelect from "../../../../ui-components/xgs-select/xgsSelect";
import { XGSSelectOption } from "../../../../ui-components/xgs-select/xgsSelect";
import Button, { ButtonThemes } from "../../../../ui-components/button/button";
import { InboundProcessingState } from "../../../../app/data/communications/models";
import { PROCESSING_STATE_LABELS } from "../constants";

const processingStateOptions: XGSSelectOption[] = [
  { value: "", label: "All statuses" },
  ...(["RECEIVED", "PROCESSING", "COMPLETED", "FAILED"] as InboundProcessingState[]).map(
    (s) => ({ value: s, label: PROCESSING_STATE_LABELS[s] })
  ),
];

export interface InboxFiltersState {
  sender: string;
  processingState: InboundProcessingState | "";
  hasPendingReview: boolean;
}

export interface InboxFiltersProps {
  filters: InboxFiltersState;
  onSenderChange: (value: string) => void;
  onProcessingStateChange: (value: InboundProcessingState | "") => void;
  onClearFilters: () => void;
}

const InboxFilters: React.FC<InboxFiltersProps> = ({
  filters,
  onSenderChange,
  onProcessingStateChange,
  onClearFilters,
}) => (
  <div className="xgs-pickup-inbox__filters">
    <LabeledTextInput
      label="Sender:"
      labelMode={LabelModes.column}
      type="text"
      value={filters.sender}
      onChange={(e) => onSenderChange(e.target.value)}
      placeholder="Filter by sender"
      className="xgs-pickup-inbox__filter-sender"
    />
    <div className="xgs-pickup-inbox__filter-status">
      <span className="xgs-pickup-inbox__filter-label">Status:</span>
      <XGSSelect
        value={processingStateOptions.find((o) => o.value === filters.processingState) ?? processingStateOptions[0]}
        options={processingStateOptions}
        onChange={(o) => onProcessingStateChange((o?.value as InboundProcessingState) || "")}
        isClearable={false}
      />
    </div>
    {filters.hasPendingReview && (
      <span className="xgs-pickup-inbox__filter-badge">Pending review only</span>
    )}
    <Button theme={ButtonThemes.gray} type="button" onClick={onClearFilters}>
      Clear filters
    </Button>
  </div>
);

export default InboxFilters;
